interface String
{
    startsWith(searchString: string, position?: number): boolean;
    toBase64String(): string;
    fromBase64String(): string;
    toBase64urlString(): string;
    fromBase64urlString(): string;
    trimEnd(char: string): string;
    padLeft(width: number, filler?: string): string;
    format(...args: any[]);
    splitJoinByCaps(seperator: string): string;
    getLeftChars(startPostion: number): string;
    getRightChars(endPosition: number): string;

    /**
     * Entfernt alle Zeichen die vor dem übergebenen Zeichen sind.
     * @param str Der string bei dem die Zeichen entfernt werden sollen.
     * @param char Alle, dem Zeichen, vorgestellten Zeichen werden entfernt.
     * @param includeChar Angabe, ob @see char ebenfalls entfernt werden soll.
     */
    removeBefore(char: string, includeChar?: boolean): string;

    /**
     * Entfernt alle Zeichen die nach dem übergebenen Zeichen sind.
     * @param str Der string bei dem die Zeichen entfernt werden sollen.
     * @param char Alle, dem Zeichen, nachgestellten Zeichen werden entfernt.
     * @param includeChar Angabe, ob @see char ebenfalls entfernt werden soll. Default ist false.
     */
    removeAfter(char: string, includeChar?: boolean): string;
}

if (typeof String.prototype.startsWith !== 'function')
{
    String.prototype.startsWith = function (searchString: string, position: number = 0)
    {
        return this.toString().indexOf(searchString, position) === position;
    };
}

if (typeof String.prototype.toBase64String !== 'function')
{
    String.prototype.toBase64String = function ()
    {
        // first we use encodeURIComponent to get percent-encoded UTF-8,
        // then we convert the percent encodings into raw bytes which
        // can be fed into btoa.
        return window.btoa(encodeURIComponent(this.toString()).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1)
            {
                return String.fromCharCode(('0x' + p1 as any));
            }));
    };
}

if (typeof String.prototype.fromBase64String !== 'function')
{
    String.prototype.fromBase64String = function ()
    {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return decodeURIComponent(window.atob(this.toString()).split('').map(function (c)
        {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    };
}

if (typeof String.prototype.toBase64urlString !== 'function')
{
    /**
     * use this to make a Base64 encoded string URL friendly, 
     * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '=' 
     * characters are removed
     * @returns {String} the URL friendly encoded String
     */
    String.prototype.toBase64urlString = function ()
    {
        return this.toString().toBase64String().trimEnd("=").replace('+', '-').replace('/', '_');
        //return (this as string).toBase64String().replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
    };
}

if (typeof String.prototype.fromBase64urlString !== 'function')
{
    /**
     * Use this to recreate a Base64 encoded string that was made URL friendly 
     * using Base64EncodeurlFriendly.
     * '-' and '_' are replaced with '+' and '/' and also it is padded with '+'
     * @returns {String} the decoded string.
     */
    String.prototype.fromBase64urlString = function ()
    {
        var str: string = this.toString().replace('_', '/').replace('-', '+');
        switch (str.length % 4)
        {
            case 2:
                str += "==";
                break;
            case 3:
                str += "=";
                break;
        }

        return str.fromBase64String();
    };
}

if (typeof String.prototype.trimEnd !== 'function')
{
    String.prototype.trimEnd = function (char: string)
    {
        char = char ? char : ' ';
        var i = this.length - 1;
        for (; i >= 0 && this.charAt(i) == char; i--);
        return this.substring(0, i + 1);
    }
}

if (typeof String.prototype.padLeft !== 'function')
{
    String.prototype.padLeft = function (width: number, filler?: string)
    {
        filler = filler || "0";
        var value: string = this.toString();
        return value.length >= width ? value : new Array(width - value.length + 1).join(filler) + value;
    };
}

if (typeof String.prototype.format !== 'function')
{
    String.prototype.format = function (...args: any[]): string
    {
        return this.toString().replace(/{(\d+)}/g, (match, number) =>
        {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };
}

if (typeof String.prototype.splitJoinByCaps !== 'function')
{
    String.prototype.splitJoinByCaps = function (seperator: string): string
    {
        return this.toString().split(/(?=[A-Z])/).join(seperator).toLowerCase();
    };
}

if (typeof String.prototype.removeBefore !== 'function')
{
    String.prototype.removeBefore = function (char: string, includeChar: boolean = true): string
    {
        var str: string = this.toString();
        if (str.indexOf(char) >= 0)
        {
            if (includeChar)
                return str.substr(str.indexOf(char) + 1, str.length);
            else
                return str.substr(str.indexOf(char), str.length);
        }
        else
        {
            return str
        }
    };
}

if (typeof String.prototype.removeAfter !== 'function')
{
    String.prototype.removeAfter = function (char: string, includeChar: boolean = false): string
    {
        var str: string = this.toString();
        if (str.indexOf(char) >= 0)
        {
            if (includeChar)
                return str.substr(0, str.indexOf(char) - 1);
            else
                return str.substr(0, str.indexOf(char));
        }
        else
        {
            return str
        }
    };
}

if (typeof String.prototype.getLeftChars !== 'function')
{
    String.prototype.getLeftChars = function (startPostion: number): string
    {
        var str: string = this.toString();
        return str.substring(0, startPostion);
    };
}

if (typeof String.prototype.getRightChars !== 'function')
{
    String.prototype.getRightChars = function (endPosition: number): string
    {
        var str: string = this.toString();
        return str.substring(endPosition, str.length);
    };
}